import { createFileRoute, Outlet } from "@tanstack/react-router";
import { guardRoute } from "@/lib/policy/route-guard";

export const Route = createFileRoute("/_authenticated/_pharmacy/med-pass-report")({
  beforeLoad: ({ context }) => guardRoute(context.me, "med-pass-report"),
  component: Outlet,
});
